import { Theme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(
    (theme: Theme) => ({
        /* Styles applied to the root element. */
        checkedIcon: {
            display: 'flex',
            justifyContent: 'space-between',
            '&:first-child': {
                flexGrow: 1,
            },
            '& svg': {
                color: 'transparent',
            },
            '&[aria-selected="true"]': {
                '& svg': {
                    color: theme.palette.success.main,
                },
            },
            '&[data-focus="true"]': {
                '& svg': {
                    color: theme.palette.action.focus,
                },
            },
            '&:active': {
                '& svg': {
                    color: theme.palette.action.active,
                },
            },
            '&[aria-disabled="true"]': {
                '& svg': {
                    color: theme.palette.action.disabled,
                },
            },
        },
    }),
    { name: 'MuiMenuOption' },
);

export default useStyles;
